/**
 * Social media links configuration.
 *
 * Add your social media URLs here. Set to empty string ('') to hide a platform.
 * Links will appear in the footer as clickable icons.
 *
 * Examples:
 *   facebook: 'https://facebook.com/yourpage'
 *   youtube: 'https://youtube.com/@yourchannel'
 *   zalo: 'https://zalo.me/yourid' or 'https://zalo.me/g/yourgroup'
 *
 * To hide a platform, set it to empty string:
 *   facebook: ''  // Facebook icon will not appear
 */
export const SOCIAL_LINKS = {
  /** Facebook page or profile URL */
  facebook: '', // TODO: Add your Facebook URL here (e.g., 'https://facebook.com/yourpage')

  /** YouTube channel URL */
  youtube: 'https://youtube.com/@xuongsoloto', // TODO: Add your YouTube URL here (e.g., 'https://youtube.com/@yourchannel')

  /** Zalo profile, page, or group URL */
  zalo: '', // TODO: Add your Zalo URL here (e.g., 'https://zalo.me/yourid' or 'https://zalo.me/g/yourgroup')
};

/**
 * Check if social media links should be displayed.
 * Returns true if at least one social link is configured.
 */
export function hasSocialLinks(): boolean {
  return Object.values(SOCIAL_LINKS).some(url => url && url.trim() !== '');
}

/**
 * Get all configured social links as an array of { platform, url } objects.
 */
export function getSocialLinks(): Array<{ platform: 'facebook' | 'youtube' | 'zalo'; url: string }> {
  return Object.entries(SOCIAL_LINKS)
    .filter(([_, url]) => url && url.trim() !== '')
    .map(([platform, url]) => ({
      platform: platform as 'facebook' | 'youtube' | 'zalo',
      url: url as string,
    }));
}
